import React from 'react';
import cn from 'classnames';

import './index.scss';

const ChartLabel = ({ isDetails, isColorRed, title, number, percentages }) => {
  return <div className={cn('doughnut-label', isDetails && '-details')}>
    <div className={cn('doughnut-label__color', isColorRed ? 'doughnut-label__color_red' : 'doughnut-label__color_green')}></div>
    <span className='doughnut-label__value'>{number}</span>
    <span className='doughnut-label__value'>({percentages}%)</span>
    <p className='doughnut-label__title'>{title}</p>
  </div>;
};

export default ChartLabel;
